import { render } from "./documentList.vue?vue&type=template&id=4b192e97&scoped=true&ts=true"
import script from "./documentList.vue?vue&type=script&lang=ts"
export * from "./documentList.vue?vue&type=script&lang=ts"

import "./documentList.vue?vue&type=style&index=0&id=4b192e97&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b192e97"]])

export default __exports__